import {Pipe, PipeTransform} from '@angular/core';
import {User} from '../../_types/user';

@Pipe({
    name: 'userName',
    standalone: true
})
export class UserNamePipe implements PipeTransform {

    transform(user: User): unknown {
        const fName = user.first_name || '';
        const lName = user.last_name || '';
        const fullName = `${fName} ${lName}`.trim();
        return fullName || user.username || user.email;
    }

}
